import React, { Fragment } from 'react'
import { useCountdown } from './../../../commons/customHooks/useCountdown'
import TimeCounter from './TimeCounter'

const TimeAward = ({award = {}, onlyTime = false}) => {
  return (
    <div className="content-awards">
      {!onlyTime ? <label className="content-awards__time">
        {award.year} {award.season}
      </label> : null}
      {!onlyTime ? <label className="content-awards__title">
        {/* {award.name} */}
        <span className="pl-2">
          AWARDS{/*{award.season_label}*/}
        </span>
      </label> : null}
      <div className="d-flex justify-content-center">
        <div className="content-time-awards">
          <label className="content-time-awards__label">
            남은 시간
          </label>
          <label className="content-time-awards__time">
            <TimeCounter award={award} />
          </label>
        </div>
      </div>
    </div>
  )
}

export default TimeAward;
